import { useContext } from "react";
import { AnswerContext } from "./AnswerProvider";

export const useAnswer = () => useContext(AnswerContext);
